module.exports = __webpack_public_path__ + "static/max_karkach-ca7a4fc78d2022bd490e02920f8c5e05.png";